<ng-container *ngFor="let fieldset of formProperty.schema.fieldsets">
  <h2 class="fieldset-legend" *ngIf="fieldset.title">
    {{ fieldset.title }}
    <sp-widget-tooltip [widget]="this"></sp-widget-tooltip>
  </h2>
  <span *ngIf="fieldset.description" class="help-block">{{ fieldset.description }}</span>
  <span *ngIf="required" class="help-block required-message">* Required</span>
  <div *ngIf="fieldset.message" [innerHTML]="fieldset.message"></div>
  <ng-container *ngFor="let fieldId of fieldset.fields">
    <sp-form-element [formProperty]="formProperty.getProperty(fieldId)"
      [class.element-hidden]="!isPropertyVisible(fieldId)"
      [attr.data-field-id]="fieldId"></sp-form-element>
  </ng-container>
</ng-container>



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/object.widget.html